import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, Ads, MODULE_ID_MAP, START_PAGE, contentBannerAds, eventBannerAds, isModuleExist, subAds } from "../../utils/Constant";
import { deleteBannerApi, getAllBannerApi } from "./Api";
import moment from 'moment';
import editPencil from "../../assets/images/edit-icon.png";
import { BANNER_AD_VERIFY, EVENT_BANNER_AD_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class AddContent extends Component {
  constructor(props) {
    super(props);
    // const AccesData = isModuleExist(Ads, props?.location?.pathname === contentBannerAds ? subAds.contentBannerAd : subAds.eventBannerAd);
    let AccesData = null;
    let verifyApi = null;
    switch (props?.location?.pathname) {
      case contentBannerAds:
        AccesData = isModuleExist(MODULE_ID_MAP.AdsContentBannerAd);
        verifyApi = BANNER_AD_VERIFY
        break;
      case eventBannerAds:
        AccesData = isModuleExist(MODULE_ID_MAP.AdsEventBannerAd);
        verifyApi = EVENT_BANNER_AD_VERIFY
        break;
      default:
        AccesData = null;
    }
    // console.log(props)
    this.state = {
      access: AccesData,
      type: props?.location?.pathname,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      verifyApi: verifyApi,
      isVerify: false,
      show: false,
    };
  }

  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllBannerApi(this);
  }
  // todo---------------------------------------

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = (id) => {
    //  console.log("yes delete  this id",)
    deleteBannerApi(id, this, this.openCloseDeleteModal)
  }

  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllBannerApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  render() {
    const { showEdit, access, type } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete  '${this.state.deleteData?.bannerAdName}' this Ads ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}

        <VerifiedModal
          name={`'${this.state.editData?.bannerAdName}'`}
          // name={`this '${this.state.editData?.bannerAdName}' banner.`}
          show={this.state.show}
          url={this.state.verifyApi + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllBannerApi(this) }}
        />

        <ComponentHeader
          breadcrumb={[["Ads", ""], [type === contentBannerAds ? "Content Banner Ads" : 'Event Banner Ad', ""]]}
          title={(type === contentBannerAds ? "Content Banner Ads" : 'Event Banner Ad')}
          primaryBtn={access.createAccess ? (type === contentBannerAds ? "Add Content Banner Ad" : 'Add Event Banner Ad') : ""}

          handlePrimaryBtn={() => {
            this.props.history(type === contentBannerAds ? '/ads/content-banner-ads/add' : '/ads/event-banner-ads/add');
          }}
          ctx={this}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">
          <CustomTable
            ctx={this}
            data={listData?.list || []}
            columns={[
              // {
              //   width: 50,
              //   title: "#",
              //   dataIndex: "id",
              //   className: "",
              //   isCell: true,
              //   render:(text, rowData, dataKey) => {
              //     if (dataKey === "id") {
              //       return "5";
              //     }
              //   },
              // },
              {
                width: 200,
                title: "Banner Name",
                dataIndex: "bannerAdName",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData.bannerAdName;
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  const color = rowData.isVerified ? 'green' : 'orange';
                  return <div className=" d-flex align-items-center inter-medium">
                    <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                      <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                    </Tag>
                  </div>;
                },
              },
              {
                width: 200,
                title: "Redirection Link",
                dataIndex: "redirectionLink",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData.redirectionLink
                },
              },
              {
                width: 140,
                title: "Keywords",
                dataIndex: "keywords",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData?.keywords?.join(', ');
                },
              },
              {
                width: 100,
                title: "Start Date",
                dataIndex: "startDate",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return moment(rowData.startDate).format('lll');
                },
              },
              {
                width: 100,
                title: "End Date",
                dataIndex: "endDate",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return moment(rowData.endDate).format('lll');
                },
              },
              // {
              //     width: 250,
              //     title: "Thumbnail Picture",
              //     dataIndex: "thumbnailPath",
              //     className: "",
              //     isCell: true,
              //     render:(text, rowData, dataKey) => {
              //       if (dataKey === "thumbnailPath") {
              //         return <Image className="table-img" src={rowData.thumbnailPath} alt="AMC Logo" />;
              //       }
              //     },
              //   },
              {
                width: 150,
                title: "Banner Image",
                dataIndex: "bannerImagePath",
                className: "",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return <Image src={rowData.bannerImagePath} className="table-img" alt="Photo" />;
                },
              },
              // {
              //   width: 170,
              //   title: "Action",
              //   dataIndex: "",
              //   className: "",
              //   isCell: true,
              //   render:(text, rowData, dataKey) => {
              //     if (dataKey === "") {
              //       return (
              //         <Button onClick={() => this.props.history({
              //           // pathname: `/campaign-detail/${rowData.uuid}`,
              //           pathname: `/add-detail/All`,
              //           search: `&key=add&value=${rowData.bannerAdName}&pageSize=${API_LIMIT}&pageNumber=${currentPage || START_PAGE}`,
              //           state: {
              //             name: rowData.bannerAdName,
              //             id: rowData.uuid
              //           }
              //         })} className=" view-details-btn inter-medium f-s-14 lh-18">
              //           View Detail
              //         </Button>
              //       );
              //     }
              //   },
              // },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData?.updatedBy?.name || 'Na';;
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData?.createdBy?.name || 'Na';
                },
              },
              {
                width: 20,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed: "right",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return (
                    // <div className="d-flex gap-4 justify-content-around">
                    //   {access.updateAccess &&
                    //     <Image src={editIcon} className="edit-icon" onClick={() => { this.props.history({ pathname: type === contentBannerAds ? '/ads/content-banner-ads/add' : '/ads/event-banner-ads/add', state: { editData: rowData } }) }} />
                    //   }
                    //   {/* <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} /> */}
                    //   {access.deleteAccess && (
                    //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                    //   )}
                    // </div>
                    <OptionsDropdown
                      editHandler={access.updateAccess ? () => { this.props.history({ pathname: type === contentBannerAds ? '/ads/content-banner-ads/add' : '/ads/event-banner-ads/add', state: { editData: rowData } }) } : null}
                      deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                    />

                  );
                },
              },
            ]}

            total={listData?.length || 0}
            loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllBannerApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddContent));
